/**
 * tor.js — feature "Apri su Tor" (premium): nasconde l'IP instradando Nullum
 * attraverso Tor. La PWA non può forzare Tor da sola (sandbox del browser):
 * guida/lancia gli strumenti lato-utente (Orbot / Onion Browser) e rileva se
 * la connessione corrente passa già per Tor.
 *
 * ⚠️ Tor nasconde l'IP, NON rende anonimi al 100% (restano metadati). Rallenta.
 */

import { callFn } from './firebase';
import { isIOS, isAndroid } from './platform';

export const TOR_LINKS = {
  orbotAndroid: 'https://orbot.app/',                 // download Orbot (anche fuori store)
  orbotIos: 'https://apps.apple.com/app/orbot/id1609461599', // Orbot iOS = VPN di sistema (tiene le notifiche)
  onionBrowserIos: 'https://onionbrowser.com/',       // alternativa iOS (browser separato, perde push)
  torBrowserDesktop: 'https://www.torproject.org/download/',
};

export function torPlatform() {
  if (isIOS()) return 'ios';
  if (isAndroid()) return 'android';
  return 'desktop';
}

/**
 * Chiede al server se la connessione corrente arriva da un exit node Tor.
 * L'IP è usato solo transitoriamente lato server (mai salvato).
 * @returns {Promise<boolean|null>} true/false, oppure null se sconosciuto.
 */
export async function checkTor() {
  try {
    const r = await callFn('checkTor')({});
    const d = r?.data;
    return d?.ok ? !!d.tor : null;
  } catch {
    return null;
  }
}

/**
 * Tenta di avviare il flusso Tor per la piattaforma (best-effort: il browser
 * non può accendere una VPN in silenzio, l'utente conferma in Orbot).
 * @returns {string} azione tentata
 */
export function openOnTor() {
  const p = torPlatform();
  if (p === 'android') {
    // Lancia Orbot se installato; altrimenti fallback al download (no store).
    const fb = encodeURIComponent(TOR_LINKS.orbotAndroid);
    window.location.href = `intent://org.torproject.android#Intent;package=org.torproject.android;S.browser_fallback_url=${fb};end`;
    return 'android-orbot';
  }
  if (p === 'ios') {
    // Apre Nullum in Onion Browser (se installato) via schema onionhttps.
    window.location.href = 'onionhttps://nullum.app';
    return 'ios-onion';
  }
  window.open(TOR_LINKS.torBrowserDesktop, '_blank', 'noopener');
  return 'desktop-torbrowser';
}
